module.exports = __webpack_public_path__ + "f516495d37e1dabf9e862fb370289056.svg";


//////////////////
// WEBPACK FOOTER
// ./src/www/images/supplier-wizard-complete.svg
// module id = 1057
// module chunks = 1